import React from 'react';
import { RotateCcwIcon, ShieldCheckIcon, TruckIcon } from 'lucide-react';
const perks = [{
  icon: TruckIcon,
  text: 'Gratis bezorgd in NL & BE'
}, {
  icon: RotateCcwIcon,
  text: '30 dagen bedenktijd'
}, {
  icon: ShieldCheckIcon,
  text: 'Garantie via ons geregeld'
}];
export function ProductPerks() {
  return <ul className="grid gap-2.5 border-t border-line pt-5 text-sm text-ink sm:grid-cols-3 sm:gap-4" data-id="element-422" data-mp="3nniw8jacmcjs">
      {perks.map(({
      icon: Icon,
      text
    }) => <li key={text} className="flex items-center gap-2" data-id="element-423" data-mp="3irbu71l2pl74">
          <Icon className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-424" data-mp="3dx7p6nvdbn8o" />
          <span className="text-xs font-medium" data-id="element-425" data-mp="38ywc849s0wm8">{text}</span>
        </li>)}
    </ul>;
}